import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, PlusCircle, Trash2 } from 'lucide-react';
import { useStore } from '../store';

const S: Record<string,string> = {DRAFT:'badge-gray',REVIEW:'badge-blue',PLANNING:'badge-amber',APPROVED:'badge-green',COMPLETE:'badge-green'};

export default function Jobs() {
  const jobs = useStore(s => s.jobs);
  const del = useStore(s => s.deleteJob);
  const [q, setQ] = useState('');
  const filtered = jobs.filter(j =>
    [j.id,j.customer,j.part_no,j.description].some(v => v?.toLowerCase().includes(q.toLowerCase()))
  );
  return (
    <div className="fade-in">
      <div className="flex-between" style={{marginBottom:24}}>
        <h1>Jobs</h1>
        <Link to="/new-job" className="btn btn-navy"><PlusCircle size={14}/> New Job</Link>
      </div>
      <div style={{position:'relative',marginBottom:16}}>
        <Search size={13} style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',color:'var(--t-faint)'}}/>
        <input className="input" style={{paddingLeft:34}} placeholder="Search jobs, customers, part numbers…" value={q} onChange={e=>setQ(e.target.value)} />
      </div>
      {filtered.length===0 ? (
        <div className="empty-state"><p>{q?'No matches.':'No jobs yet.'}</p></div>
      ) : (
        <div className="card" style={{padding:0}}>
          <table>
            <thead><tr><th>Job ID</th><th>Part No.</th><th>Description</th><th>Customer</th><th>Template</th><th>Machine</th><th>Status</th><th>Date</th><th></th></tr></thead>
            <tbody>
              {filtered.map(j=>(
                <tr key={j.id}>
                  <td><Link to={`/jobs/${j.id}`} style={{color:'var(--c-blue)',textDecoration:'none',fontFamily:'var(--mono)',fontSize:11}}>{j.id}</Link></td>
                  <td style={{fontFamily:'var(--mono)',fontSize:12,fontWeight:500,color:'var(--t-primary)'}}>{j.part_no||'—'}</td>
                  <td style={{maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontSize:12}}>{j.description||'—'}</td>
                  <td>{j.customer||'—'}</td>
                  <td>{j.template&&<span className="badge badge-navy">{j.template}</span>}</td>
                  <td style={{fontSize:12}}>{j.selected_machine?.replace(/_/g,' ')||'—'}</td>
                  <td><span className={`badge ${S[j.status]??'badge-gray'}`}>{j.status}</span></td>
                  <td style={{fontSize:11,color:'var(--t-faint)'}}>{new Date(j.created_at).toLocaleDateString('en-IN')}</td>
                  <td><button className="btn btn-ghost btn-sm" onClick={()=>{if(window.confirm('Delete?'))del(j.id)}}><Trash2 size={11}/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
